import { render, staticRenderFns } from "./Articulados.vue?vue&type=template&id=5c9c1c86"
import script from "./Articulados.vue?vue&type=script&lang=js"
export * from "./Articulados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports